import React from 'react'

type PdfViewerProps = {
  base64DATA: string
}

const PdfViewer: React.FC<PdfViewerProps> = ({ base64DATA }) => (
  <>
    <style>
      {`
        .pdf-container {
          height: 350px;
        }

        .pdf-container iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
      `}
    </style>

    <div className="pdf-container">
      {' '}
      <iframe
        src={`${base64DATA}#toolbar=0&zoom=100`}
        width="100%"
        height="100%"
        title="Visualizador de PDF"
      />{' '}
    </div>
  </>
)

export default PdfViewer
